import useSummary from "../../../../../../hooks/summary/useSummary";
import { apiEndPoints, clearStorage } from "../../../../../../config/config";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateErrorMessage } from "../../../../../../store/error_slice";
import Wrapper from "./components/Wrapper/main";
import { topPerformingAgentType, topAgentItemType } from "./performance.types";
import APIError from "../../../../../../api/Error/error";
const Performance = () => {
  const { SUMMARY_API_TOPAGENT } = apiEndPoints;
  const dispatch = useDispatch();
  const [listData, setListData] = useState<topAgentItemType[]>([]);
  const performanceSucces = (apiRes: topPerformingAgentType) => {
    const { results } = apiRes;
    setListData(results);
  };
  const performanceError = (error: APIError) => {
    try {
      if (error.statusCode === 401) {
        //logout
        clearStorage();
        // navigate("/login");
        window.location.reload();
      } else {
        dispatch(
          updateErrorMessage({ message: error.message, type: "summary" }),
        );
      }
    } catch (err) {
      dispatch(
        updateErrorMessage({
          message: "Something went wrong",
          type: "summary",
        }),
      );
    }
  };
  const { isLoading, isFetching, isError, refetch } = useSummary({
    queryKey: ["top-agent"],
    onSucces: performanceSucces,
    onError: performanceError,
    url: SUMMARY_API_TOPAGENT,
  });
  const refetchHandler = () => {
    refetch();
  };
  useEffect(() => {
    refetchHandler();
  }, []);
  return (
    <Wrapper
      isError={isError}
      isLoading={isLoading}
      isFetching={isFetching}
      listData={listData}
      refetch={refetchHandler}
    />
  );
};
export default Performance;
